import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '../../core/core.module';
import { DownloadLogComponent } from './download-log.component';
import { TableModule } from 'primeng/table';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    NgbModule,
    TableModule,
    TranslateModule
  ],
  declarations: [DownloadLogComponent],
  entryComponents: [DownloadLogComponent],
})
export class DownloadLogModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download-log/download-log.module.ts